export default __webpack_public_path__ + "static/media/leaf.b5bbba24.png";